import { getContent } from "../utils/getContent";
import he from "he";

const getProp = () => async (path, prop) => {
    const contentNode = await getContent(path).then(response => {
        return response.json();
    });
    return contentNode[prop] ? he.decode(contentNode[prop]) : "";
};

export default getProp;
